import { Box, Button, Divider, Grid, Rating, Typography } from '@mui/material'
import React from 'react'
import { withTranslation } from 'react-i18next'
import StarIcon from '@mui/icons-material/Star';
import { BsArrowLeft, BsPersonCircle } from 'react-icons/bs';
// import { useState } from 'react';
// import { array } from 'yup';
// import { useDispatch } from 'react-redux';
// import { previewModal } from 'store/slices/miscSlice';
import { useContext } from 'react';
import { ReviewContext } from './reviewContext';
import ReviewChart from './ReviewChart';
import useSWR from 'swr';

function ReviewComment() {
    const { setShowReviewChart, setShowComment, currentBranch } = useContext(ReviewContext)

    const { data: singeBranchRating } = useSWR(`merchants/ratings/branch/${currentBranch.id}`)

    // console.log( `${((singeBranchRating?.data?.data.filter(x => x.rating > 0 && x.rating < 1.01).length / singeBranchRating?.data?.total) * 100).toFixed(2) }%` )
    // extract number of each rating 5,4,3,2,1
    let ratingsLine = [
        { 1: `${((singeBranchRating?.data?.data.filter(x => x.rating > 0 && x.rating < 1.01).length / singeBranchRating?.data?.total) * 100).toFixed(2)}%` },
        { 2: `${((singeBranchRating?.data?.data.filter(x => x.rating > 1 && x.rating < 2.01).length / singeBranchRating?.data?.total) * 100).toFixed(2)}%` },
        { 3: `${((singeBranchRating?.data?.data.filter(x => x.rating > 2 && x.rating < 3.01).length / singeBranchRating?.data?.total) * 100).toFixed(2)}%` },
        { 4: `${((singeBranchRating?.data?.data.filter(x => x.rating > 3 && x.rating < 4.01).length / singeBranchRating?.data?.total) * 100).toFixed(2)}%` },
        { 5: `${((singeBranchRating?.data?.data.filter(x => x.rating > 4 && x.rating < 5.01).length / singeBranchRating?.data?.total) * 100).toFixed(2)}%` }
    ]
    // const [addComment, setAddComment] = useState([])
    // const show = (i, bool) => {
    //     setAddComment([])
    //     let arr = []
    //     arr[i] = bool;
    //     setAddComment(arr)
    // }
    // const dispatch = useDispatch()
    const commonTextStyle = { fontSize: '16px', fontWeight: '400', lineHeight: '24px', textTransform: 'none' }
    return (
        <>
            <Button className='absolute right-[5%] top-[130px] py-3' onClick={() => setShowComment(false)} variant='outlined'> <BsArrowLeft /> </Button>
            <div className='flex flex-col w-full h-[100%] gap-[5px]'>
                <Box width={{ xs: '100%', md: '50%' }} className='h-[10%] flex justify-between items-center'>
                    <Typography sx={{ fontSize: { xs: '1.4rem', lg: '1.8ren' }, fontWeight: '700', color: '#657585' }}>{currentBranch?.name} Review</Typography>
                    <Box className='text-right'>{currentBranch.total} reviews</Box>
                </Box>
                <col />
                <Grid container className='h-[90%] w-full pt-5 justify-between'>
                    <Grid item xs={12} lg={6} className='h-[100%] flex flex-col gap-[20px]' sx={{ overflowY: 'auto' }}>
                        {
                          singeBranchRating?.data?.data?.length ? ( singeBranchRating?.data?.data.map((x, i) => {
                                return (
                                    <Box key={i} display={'flex'} flexDirection={'column'} gap={'18px'}>
                                        <Rating
                                            name="text-feedback"
                                            defaultValue={x.rating}
                                            readOnly
                                            precision={x.rating}
                                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                        />
                                        <Typography sx={{ ...commonTextStyle, color: '#657585' }}>
                                            {x.description}
                                        </Typography>

                                        <Box display={'flex'} className={'w-full flex justify-between pr-2'}>
                                            <Typography sx={{ ...commonTextStyle, color: '#05213D' }} className='flex gap-[10px] items-center'>
                                                {x.user_avatar ? <img src={x.user_avatar} width={32} alt='' /> : <BsPersonCircle size={32} color='grey' />}
                                                {x.username}
                                            </Typography>

                                            <Typography sx={{ ...commonTextStyle, fontSize: '12px', color: '#657585', }}>
                                                {x.created_at}
                                            </Typography>
                                        </Box>

                                        {/* <Button variant='text' onClick={() => show(i, true)}
                                            component={'a'} style={{ ...commonTextStyle, color: '#1976D2', width: 'fit-content', }}>
                                            Add comment
                                        </Button> */}

                                        {/* <Box className={`flex flex-col gap-[16px] ${addComment[i] ? '' : 'hidden'}`}>
                                            <input type='text' className='w-[99%] bg-[#F0F3F5] mx-auto p-3 rounded-[12px] focus:border-none' placeholder='Add a comment' />
                                            <Box className='flex gap-[10px]'>
                                                <Button onClick={() => show(i, false)} variant={'outlined'} className='px-4 py-2 rounded-[10px]' component={'a'} sx={{ ...commonTextStyle, color: '#1976D2', width: 'fit-content' }}>
                                                    Cancel
                                                </Button>
                                                <Button variant={'contained'} className='px-4 py-2 rounded-[10px]' component={'a'} sx={{ ...commonTextStyle, width: 'fit-content' }}>
                                                    Comment
                                                </Button>
                                            </Box>
                                        </Box> */}
                                        <Divider sx={{ my: '10px' }} />
                                    </Box>
                                )
                            }) ) : <div className='h-[100%] w-[100%] flex items-center justify-center'><h1 className='text-bold'>No comments</h1>                            </div>
                        }
                    </Grid>
                    <Grid item xs={12} lg={6} className='h-[100%] flex justify-center'>
                        <Box className='h-[344px] w-[364px] rounded-[16px] p-[24px] flex flex-col justify-between' border={'1px solid #D3D7DB'}>
                            <Typography variant='h6' color={'#657585'}>{currentBranch.name} Average</Typography>
                            <Box className='flex mt-5 mx-auto text-center justify-between items-center w-[100%]'>
                                <Box className='w-[45%]'>
                                    <Typography variant='h2' color='black' fontWeight={700}>{singeBranchRating?.data?.rating}</Typography>
                                    <Typography fontWeight={'700'} color='black'>Out of 5</Typography>
                                </Box>
                                <Box className='w-[55%] flex flex-col gap-[16px] py-5'>
                                    {ratingsLine.map((x, i) => {
                                        return <Box key={i} sx={{ bgcolor: '#D3D7DB', width: '90%', height: '6px', }} className='rounded-[7px] flex items-center'>
                                            <Box sx={{ bgcolor: '#657585', width: x[i + 1], height: '7px' }} className='rounded-[7px] border' ></Box>
                                        </Box>
                                    })}
                                </Box>
                            </Box>
                            <Box className='w-full text-right text-[#05213D]'>
                                {singeBranchRating?.data?.total} ratings
                            </Box>
                            <Button variant='outlined' className='w-full h-[54px] rounded-[16px]' onClick={() => setShowReviewChart(true)}>
                                View chart
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <ReviewChart currentBranch={currentBranch} />
            </div></>
    )
}

export default withTranslation()(ReviewComment)